import { Chevron, theme } from '@lmc/ui-kit'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { useRouter } from 'hooks/useRouter'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { GeneralText } from '../styledComponents'

type GeneralAlertsSectionProps = {
  alertsText: string
  testId?: string
}

export const GeneralAlertsSection = ({
  alertsText,
  testId
}: GeneralAlertsSectionProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const router = useRouter()

  return (
    <CoreSectionWrapper
      data-testid={
        testId ? `${testId}-alerts-section` : 'resident-alerts-section'
      }
    >
      <CoreSection
        data-testid={testId ? `${testId}-alerts-info` : 'resident-alerts-info'}
      >
        <StyledCoreLabel
          level={2}
          data-testid={
            testId ? `${testId}-alerts-label` : 'resident-alerts-label'
          }
        >
          Alerts
        </StyledCoreLabel>
        <GeneralText
          weight="bold"
          data-testid={
            testId ? `${testId}-alerts-value` : 'resident-alerts-value'
          }
        >
          {alertsText}
        </GeneralText>
      </CoreSection>
      <CoreSection
        data-testid={
          testId ? `${testId}-alerts-actions` : 'resident-alerts-actions'
        }
      >
        <Button
          variant="text"
          onClick={() =>
            router.navigate(`/residents/${router?.params?.id}/alerts`)
          }
          data-testid={
            testId
              ? `${testId}-alerts-details-button`
              : 'resident-alerts-details-button'
          }
        >
          {t(supConstants.VIEW_ALERTS_DETAILS)}
          <Chevron direction="right" color={theme.color.status.primary} />
        </Button>
      </CoreSection>
    </CoreSectionWrapper>
  )
}

const StyledCoreLabel = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const CoreSectionWrapper = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.color.neutral.color7};
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  padding-top: 16px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
  }
`

const CoreSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-top: 15px;
  }
`
